export const Dashboard = ({ hasPermission }:
    { hasPermission: (pageName: string, featureName?: string) => boolean; }) => {
    return (<div>
        <h3>Dashboard</h3>
    </div>);
}